import React from "react";

const Wallet = (props) => {
  return (
    <svg
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.73842 6.38149C2.25652 6.38149 1.04761 5.17258 1.04761 3.69069C1.04761 2.20879 2.25652 0.999878 3.73842 0.999878C4.08382 0.999878 4.36237 1.27843 4.36237 1.62383C4.36237 1.96924 4.08382 2.24779 3.73842 2.24779C2.94733 2.24779 2.30109 2.89403 2.30109 3.68511C2.30109 4.4762 2.94733 5.12244 3.73842 5.12244C4.08382 5.12244 4.36237 5.40099 4.36237 5.7464C4.36237 6.0918 4.08382 6.37035 3.73842 6.37035V6.38149Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M16.5743 2.24988H3.65377C3.35498 2.24988 3.11401 1.97086 3.11401 1.62488C3.11401 1.2789 3.35498 0.999878 3.65377 0.999878H16.5743C16.8731 0.999878 17.114 1.2789 17.114 1.62488C17.114 1.97086 16.8731 2.24988 16.5743 2.24988Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M21.0641 14.3033H17.0251C15.9833 14.3033 15.1365 13.4565 15.1365 12.4147V9.69607C15.1365 8.65429 15.9833 7.8075 17.0251 7.8075H21.0641C22.1058 7.8075 22.9526 8.65429 22.9526 9.69607V12.4147C22.9526 13.4565 22.1058 14.3033 21.0641 14.3033ZM17.0251 9.06098C16.6741 9.06098 16.39 9.3451 16.39 9.69607V12.4147C16.39 12.7657 16.6741 13.0498 17.0251 13.0498H21.0641C21.415 13.0498 21.6991 12.7657 21.6991 12.4147V9.69607C21.6991 9.3451 21.415 9.06098 21.0641 9.06098H17.0251Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M18.1541 12.3425C17.7389 12.3425 17.4041 12.064 17.4041 11.7186V10.3982C17.4041 10.0528 17.7389 9.77429 18.1541 9.77429C18.5692 9.77429 18.9041 10.0528 18.9041 10.3982V11.7186C18.9041 12.064 18.5692 12.3425 18.1541 12.3425Z"
        fill={props.color}
      />
      <path
        d="M18.0671 16.9999H3.65485C2.21752 16.9999 1.04761 15.83 1.04761 14.3982V3.69068C1.04761 3.34528 1.32616 3.06116 1.67713 3.06116C2.02811 3.06116 2.30109 3.33971 2.30109 3.68511V14.3926C2.30109 15.1392 2.90833 15.7464 3.65485 15.7464H18.0671C18.8136 15.7464 19.4209 15.1392 19.4209 14.3926V13.674C19.4209 13.3286 19.6994 13.05 20.0448 13.05C20.3902 13.05 20.6688 13.3286 20.6688 13.674V14.3926C20.6688 15.83 19.4989 16.9999 18.0615 16.9999H18.0671Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M20.0444 9.0612C19.699 9.0612 19.4204 8.78265 19.4204 8.43724V7.72972C19.4204 6.98321 18.8132 6.37596 18.0667 6.37596H3.73797C3.39257 6.37596 3.11401 6.09741 3.11401 5.75201C3.11401 5.4066 3.39257 5.12805 3.73797 5.12805H18.0667C19.504 5.12805 20.6739 6.29797 20.6739 7.73529V8.44282C20.6739 8.78822 20.3954 9.06677 20.0499 9.06677L20.0444 9.0612Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M18.4264 4.99422C18.1117 4.99422 17.8579 4.71134 17.8579 4.36056V3.64203C17.8579 2.8839 17.3046 2.2672 16.6244 2.2672H3.56853C3.25381 2.2672 3 1.98432 3 1.63354C3 1.28276 3.25381 0.999878 3.56853 0.999878H16.6244C17.934 0.999878 19 2.188 19 3.64769V4.36621C19 4.71699 18.7462 4.99988 18.4315 4.99988L18.4264 4.99422Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default Wallet;
